<template>
    <section style="margin: 0px !important">
      <div id="backBox"></div>
      <Navbar />

      <!-- 2 columns for main page -->
      <div class="mainFlex">
        <!-- FIRST COLUMN -->
        <div class="flexLeft">
          <Groups />
        </div>

        <!-- MAIN BLOCK -->
        <div class="reviewContainer">
          <div class="reviewBar">
              <div class="starBox">
                <img src="@/assets/Reviews/75Bar.svg" class="star"/>                      
                <p class="starText">4/5</p>
              </div>
            <p class="reviewText">{{groupName}} Average GPA: 3.3</p>
            <div class="addReview">
              <div class="addButton">
                <p class="addText">Add Review+</p>
              </div> 
            </div>
          </div>
          <div class="tabBar">
            <div class="firstButton">All Reviews</div>
            <div class="tabButton">Albert Einstein</div>
            <div class="tabButton">Mark Twain</div>
            <div class="tabButton">Victor Hugo</div>
            <div class="tabButton">John Adams</div>
            <div class="tabButton">Add Professor+</div>
          </div>
          <div class="reviewBox">
            <div class="reviewRow">
              <b class="reviewDesc">Anonymous</b>
              <div class="reviewDesc">
                This is definitely one of my favourite classes I've taken this far! The prof gives off an amazing vibe and has great presentation skills. Exams are easy if you put in the work and TAs are really knowledgeable.
              </div>
              <div class="reviewRowBar">
                <p class="reviewBarText">Rating 5/5</p>
                <p class="reviewBarText">87%</p>
                <p class="reviewBarText">John Adams</p>
                <p class="reviewBarText">Feb 23rd, 2021</p>
              </div>
              
            </div>
            <div class="reviewRow">
              <div class="reviewDesc">
                Great Content, Love the content
              </div>
              <div class="reviewRowBar">
                <p class="reviewBarText">John Smith</p>
                <p class="reviewBarText">Rating 5/5</p>
                <p class="reviewBarText">GPA: 3.7</p>
                <p class="reviewBarText">Prof 1</p>
                <p class="reviewBarText">Feb 12th, 2021</p>
              </div>
            </div>
            <div class="reviewRow">
              <div class="reviewDesc">
                Absolutely Amazing Professor, 100% Recommmend!
              </div>
              <div class="reviewRowBar">
                <p class="reviewBarText">Anonymous</p>
                <p class="reviewBarText">Rating 4/5</p>
                <p class="reviewBarText">GPA: 3.3</p>
                <p class="reviewBarText">Prof 2</p>
                <p class="reviewBarText">Jan 25th, 2021</p>
              </div>
            </div>

          </div>

        </div>
      </div>
    </section>
</template> 

<script>
import { mapState } from "vuex";
import Groups from "@/components/Groups";
import Navbar from "@/components/Navbar";

export default {
  components: {
      Groups,
      Navbar,
  },

  computed: {
    ...mapState("messageBoard", ["groupId","groupName"]),
  },
}
</script>

<style src="@/styles/Reviews.css"></style>